import React from "react";

// Matches travel-qr Button exactly — plain <button> with Gilroy, same sizes as source
const TEAL = "#079f9f";

const baseStyle = {
  width: "100%",
  fontFamily: "'Gilroy', -apple-system, Roboto, Helvetica, sans-serif",
  fontWeight: 600,
  fontSize: 14,     /* text-sm (mobile). Desktop applies media query via inline style override via CSS */
  borderRadius: 8,
  border: "none",
  cursor: "pointer",
  display: "inline-block",
  boxSizing: "border-box",
  transition: "background-color 0.15s",
  padding: "12px 12px",   /* py-3 px-3 mobile */
};

const variants = {
  primary: {
    ...baseStyle,
    backgroundColor: TEAL,
    color: "white",
  },
  outlined: {
    ...baseStyle,
    backgroundColor: "white",
    color: TEAL,
    border: `1px solid ${TEAL}`,
  },
  secondary: {
    ...baseStyle,
    backgroundColor: "transparent",
    border: "none",
    color: TEAL,
    width: "auto",
    padding: 0,
    fontSize: 12,
  },
};

const disabledStyle = {
  opacity: 0.5,
  cursor: "not-allowed",
};

export default function TravelButton({
  variant = "primary",
  clickText,
  onClick,
  disabled = false,
  id,
  children,
}) {
  const style = {
    ...(variants[variant] || variants.primary),
    ...(disabled ? disabledStyle : {}),
  };

  return (
    <button
      id={id}
      style={style}
      onClick={disabled ? (e) => e.preventDefault() : onClick}
      disabled={disabled}
      type="button"
    >
      {children ? children : <span>{clickText}</span>}
    </button>
  );
}
